import React, { useState, useRef, useEffect } from "react";

import FormField from "@awsui/components-react/form-field";
import Alert from "@awsui/components-react/alert";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Button from "@awsui/components-react/button";
import TokenGroup from "@awsui/components-react/token-group";
import SpaceBetween from "@awsui/components-react/space-between";
import ProgressBar from "@awsui/components-react/progress-bar";
import Pagination from "./pagelist";

import ALLOWED_EXTENSIONS from "../allowed-extensions.js";

import { Auth, Storage } from "aws-amplify";
import { API } from 'aws-amplify';

import { Modal } from "antd";



const Main = () => {
  
  const refUploadToFolder = useRef();
  const hiddenFileInput = useRef(null);
  const hiddenFolderInput = useRef(null);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [uploadList, setUploadList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [historyList, setHistoryList] = useState([]);
  const [historyCount, setHistoryCount] = useState(0);
  const [username, setUsername] = useState("");
  const [uploadToFolder, setUploadToFolder] = useState("");
  const [isValidFolderPath, setIsValidFolderPath] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentData = historyList.slice(startIndex, endIndex);
  
  
  /* Fetch Authenticated user information, run only on initial render */
  useEffect(() => {
    (async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (user.username == "test") {
          setUsername("testuser");
        } else {
          setUsername(user.username);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  function checkFileType(filename, mimeType) {
    const extension = filename.split('.').pop().toLowerCase();
    return ALLOWED_EXTENSIONS.some(type => 
      type.extension === extension && type.mime_type === mimeType
    );
  }

  function allowed_files(targetFiles){
    let resultList = [];
    for (let i = 0; i < targetFiles.length; i++) {
      let isValid = checkFileType(targetFiles[i].name, targetFiles[i].type);
      const epoch = Math.floor(new Date().getTime() / 1000);
      resultList.push({
        name: targetFiles[i].name,
        username: username +'_'+ epoch.toString() +'_'+ i.toString() ,
        epoch: epoch.toString(),
        user: username,
        isValid: isValid,
        fileSize: targetFiles[i].size,
        mimeType: targetFiles[i].type,
        ts: new Date().toLocaleString(),
        batchSize : targetFiles.length
      });
    }
    return resultList;
  }
  
  function getInvalidOrAllFilenames(fileObjects, onlyInvalid = false) {
    return fileObjects
      .filter(file => !onlyInvalid || !file.isValid)
      .map(file => file.name)
      .join(', ');
  }

  function alertDisallowedFiles(invalidFilesStr) {
    Modal.error({
      title: "Invalid file type upload",
      content:
        `The following file(s) are invalid, please verify ${invalidFilesStr}`,
      });
  }

  async function logToAPI(data, upload_flag) {
    const fullData = data.map(obj =>({ 
      ...obj, 
      clearForUpload: upload_flag
    }));
    try {
      const response = await API.post('cmrlogsapi', '/logs', { body: fullData });
      console.log('Logged upload data');
      //return { success: true, message: 'Logs sent successfully' };
    } catch (error) {
      console.warn('Error logging upload data:', error);
      //return { success: false, message: 'Error sending logs.' };
    }
  };
  



  const handleClick = (selected) => {
    //let x = all_image_types();
    if (selected == "File") {
      hiddenFileInput.current.value = ""; // This avoids errors when selecting the same files multiple times
      hiddenFileInput.current.click();
    } else {
      hiddenFolderInput.current.value = ""; // This avoids errors when selecting the same files multiple times
      hiddenFolderInput.current.setAttribute("directory", "");
      hiddenFolderInput.current.setAttribute("webkitdirectory", "");
      hiddenFolderInput.current.click();
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    let upload_flag = false;
    let i, tempUploadList = [];  
    let allowed_file_check = allowed_files(e.target.files);
    let invalidFilesStr= getInvalidOrAllFilenames(allowed_file_check, true);
    if (invalidFilesStr!=""){
      alertDisallowedFiles(invalidFilesStr);
    }
    else{
      for (i = 0; i < e.target.files.length; i++) {
        tempUploadList.push({
          label:
            e.target.files[i].webkitRelativePath == ""
              ? e.target.files[i].name
              : e.target.files[i].webkitRelativePath,
          labelTag: formatBytes(e.target.files[i].size),
          description: "File type: " + e.target.files[i].type,
          icon: "file",
          id: i,
        });
      }
      setVisibleAlert(false);
      setUploadList(tempUploadList);
      setFileList(e.target.files);
      upload_flag=true;
    }
    logToAPI(allowed_file_check, upload_flag);
  };
  

  function progressBarFactory(fileObject) {
    let localHistory = historyList;
    const id = localHistory.length;
    localHistory.push({
      id: id,
      percentage: 0,
      filename:
        username +
        "/" +
        (uploadToFolder == "" ? "" : uploadToFolder + "/") +
        (fileObject.webkitRelativePath == ""
          ? fileObject.name
          : fileObject.webkitRelativePath),
      filetype: "", //fileObject.type,
      filesize: "",
      status: "in-progress",
    });
    setHistoryList(localHistory);
    return (progress) => {
      let tempHistory = historyList.slice();
      const percentage = Math.round((progress.loaded / progress.total) * 100);
      tempHistory[id].percentage = percentage;
      if (percentage === 100) {
        tempHistory[id]["status"] = "success";
        tempHistory[id]["filename"] = tempHistory[id]["filename"].replace('UPLOADING','UPLOADED');
        console.log(tempHistory[id]);
        tempHistory[id]["filetype"] = formatBytes(fileObject.size) + " - " + new Date().toLocaleString();
      } else {
        // display 'uploading' only once
        if (!tempHistory[id]["filename"].startsWith('UPLOADING')){
            tempHistory[id]["filename"] = "UPLOADING - " + tempHistory[id]["filename"];
            tempHistory[id]["filetype"] = formatBytes(fileObject.size) + " - " + new Date().toLocaleString();
        }
      }
      setHistoryList(tempHistory);
    };
  }
  
  
  function formatBytes(a, b = 2, k = 1024) {
    let d = Math.floor(Math.log(a) / Math.log(k));
    return 0 === a
      ? "0 Bytes"
      : parseFloat((a / Math.pow(k, d)).toFixed(Math.max(0, b))) +
          " " +
          ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
  }
  
  function checkFolderPath(path) {
    let regExp = new RegExp(
      "(^[a-zA-Z0-9 ,_-s'+()/]*$)(?<!.*?/{2,}.*$)(?<!.*/$)"
      //in first () only allow these chars
      //in second () not allow sequences of two or more / anywhere
      //in last () not allow / and the end
    );
    let isValidPath = regExp.test(path);
    setIsValidFolderPath(isValidPath);
    if (isValidPath) {
      setUploadToFolder(path.startsWith("/") ? path.slice(1) : path);
    }
    return isValidPath;
  }
  


  const handleUpload = () => {
    if (uploadList.length === 0) {
      setVisibleAlert(true);
    } else {
      let i,
        progressBar = [],
        uploadCompleted = [];
      for (i = 0; i < uploadList.length; i++) {
        // If the user has removed some items from the Upload list, we need to correctly reference the file
        const id = uploadList[i].id;
        const fullPath =
          username +
          "/" +
          (uploadToFolder == "" ? "" : uploadToFolder + "/") +
          (fileList[id].webkitRelativePath == ""
            ? fileList[id].name
            : fileList[id].webkitRelativePath);
        progressBar.push(progressBarFactory(fileList[id]));
        setHistoryCount(historyCount + 1);
        uploadCompleted.push(
          Storage.put(fullPath, fileList[id], {
            progressCallback: progressBar[i],
            metadata: {
              uploadedBy: username,
            },
          }).then((result) => {
            // Trying to remove items from the upload list as they complete. Maybe not work correctly
            // setUploadList(uploadList.filter(item => item.label !== result.key));
          })
        );
      }
      // When you finish the loop, all items should be removed from the upload list
      Promise.all(uploadCompleted).then(() => setUploadList([]));
    }
  };

  const handleDismiss = (itemIndex) => {
    setUploadList([
      ...uploadList.slice(0, itemIndex),
      ...uploadList.slice(itemIndex + 1),
    ]);
  };
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  
  const handleClearHistory = () => {
    setHistoryList([]);
  };
  
  const AddToHistory = (action, file) => {
    let localHistory = historyList;
    const id = localHistory.length;
    localHistory.push({
      id: id,
      percentage: 0,
      filename: action + " - " + file,
      filetype: new Date().toLocaleString(),
      filesize: "",
      status: "",
    });
    setHistoryList(localHistory);

    // UI update on second setHistoryList ?????
    
    if (action.indexOf("FAILED") === -1) {
      let tempHistory = historyList.slice();
      tempHistory[id].percentage = 100;
      tempHistory[id]["status"] = "success";
      setHistoryList(tempHistory);
      
    } else {
      console.log(historyList);
      let tempHistory = historyList.slice();
      tempHistory[id]["status"] = "unsuccess";
    }
  };
  
  
  const SetFolderToUploadTo = (folder, uploadType) => {
    if (folder.startsWith(username)) {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        "value"
      ).set;
      //set value to input
      if (folder.indexOf("/") > -1)
        nativeInputValueSetter.call(
          refUploadToFolder.current,
          folder.replace(username + "/", "")
        );
      else
        nativeInputValueSetter.call(
          refUploadToFolder.current,
          folder.replace(username, "")
        );
      // trigger event onChange
      const inputEvent = new Event("input", { bubbles: true });
      refUploadToFolder.current.dispatchEvent(inputEvent);
      if (uploadType == "File") document.getElementById("ChooseFiles").click();
      else document.getElementById("ChooseFolders").click();
    }
  };
  
  // props go here because it doesnt know what is AddToHistory if it load before AddToHistory
  let props = {
    historyList: historyList,
    username: username,
    addActionedFileToHistory: AddToHistory,
    gpSetFolderToUploadTo: SetFolderToUploadTo,
  };

  return (
    <SpaceBetween size="1">
      <div style={{ display: "flex" }}>
        <Container
          id="s3-upload-multiple-objects"
          header={<Header variant="h2">Upload</Header>}
        >
          {
            <div>
              <Alert
                onDismiss={() => setVisibleAlert(false)}
                visible={visibleAlert}
                dismissAriaLabel="Close alert"
                dismissible
                type="error"
                header="No files selected"
              >
                You must select the files that you want to upload.
              </Alert>

              <FormField
                // label="Object Upload"
                description="Enter name of the folder you want to upload to in the textbox below ex: a or a/b or a/b/c"
              />
              <input
                type="file"
                multiple
                id="filepicker"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: "none" }}
              />
              <input
                type="file"
                multiple
                id="folderpicker"
                ref={hiddenFolderInput}
                onChange={handleChange}
                style={{ display: "none" }}
              />
              <SpaceBetween direction="horizontal" size="xs">
                <div>
                  <span className="inputAnt-outer">
                    <span className="inputAnt-wrapper">
                      <span className="inputAnt-addonBefore">{username}/</span>
                      <input className="inputAnt"
                        ref={refUploadToFolder}
                        // value= {uploadToFolder} doesnt work as expected.UseRef is working (check SetFolderToUploadTo)
                        onChange={(e) => {
                          checkFolderPath(e.target.value);
                        }}
                        onBlur={(e) => {
                          if (!checkFolderPath(e.target.value))
                            Modal.error({
                              title: "This is an error message",
                              content:
                                "You won't able to upload because you have entered invalid folder path. Please try another one.",
                            });
                        }}
                      />
                    </span>
                  </span>
                </div>
                <Button
                  onClick={(e) => handleClick("File")}
                  iconAlign="left"
                  iconName="upload"
                  id="ChooseFiles"
                >
                  File[s]
                </Button>

                <Button
                  onClick={(e) => handleClick("Folder")}
                  iconAlign="left"
                  iconName="upload"
                  id="ChooseFolders"
                >
                  Folder[s]
                </Button>

                <Button
                  disabled={!isValidFolderPath}
                  variant="primary"
                  onClick={handleUpload}
                >
                  Upload
                </Button>
              </SpaceBetween>

              <TokenGroup
                onDismiss={({ detail: { itemIndex } }) => {
                  handleDismiss(itemIndex);
                }}
                items={uploadList}
                alignment="vertical"
                limit={10}
              />
            </div>
          }
        </Container>

        <Container id="history" header={<Header variant="h2">History</Header>}>
          {currentData.map((item) => (
            <ProgressBar
              key={item.id}
              status={item.status}
              value={item.percentage}
              variant="standalone"
              additionalInfo={item.filesize}
              description={item.filetype}
              label={item.filename}
            />
          ))}
          {historyList.length > 0 ? (
            <Pagination
              pageSize={pageSize}
              currentPage={currentPage}
              totalData={historyList.length}
              onPageChange={handlePageChange}
              onClearHistory={handleClearHistory}
            />
          ) : (
            <></>
          )}
        </Container>
      </div>
    </SpaceBetween>
  );
};

export default Main;